import React, { useState, useEffect } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import {
  Col,
  Nav,
  NavItem,
  TabContent,
  TabPane,
  NavLink,
  Container,
  Alert,
  Card,
  CardBody,
} from 'reactstrap';
import classnames from 'classnames';
import List from '@material-ui/core/List';
import format from 'date-fns/format';
import ListItem from '@material-ui/core/ListItem';
import PropTypes from 'prop-types';
import { MuiThemeProvider } from 'material-ui/styles';
import { v4 as uuid } from 'uuid';
import SockJS from 'sockjs-client';
import Stomp from 'stompjs';
import SmartGoCard from './components/SmartGoCard';
import SideBar from './components/SideBar';
import {
  DEFAULT_API_URL,
  FINISHED_ITEMS_TAB,
  RUNING_ITEMS_TAB,
  SMARTGO_STATUS,
  TAB,
} from '../../shared/utils/constants';
import { getDomain, getToken } from '../../auth';
import GraphQL from '../../GraphQL';
import {
  saveSmartGoMutation,
  smartGoByStatus,
  smartGoPendencyQuantity,
} from '../../shared/queries/SmartGo';
import { showNotificationAutoDestroy } from '../../shared/components/ShowNotification';
import { updatePendency } from '../../shared/utils/smartutils';

let stompClient;

const SmartGo = (props) => {
  const { t, dispatch } = props;
  const [selectedDto, setSelectedDto] = useState({});
  const [isOpenSide, setIsOpenSide] = useState(false);
  const [filterArrived, setFilterArrived] = useState([]);
  const [filterRadius, setFilterRadius] = useState([]);
  const [filterOnTheMove, setFilterOnTheMove] = useState([]);
  const [filterDone, setFilterDone] = useState([]);
  const token = getToken();
  const getActiveTab = () => sessionStorage.getItem(TAB);
  const activeTab = getActiveTab();

  const toggleSideBar = () => {
    setIsOpenSide(!isOpenSide);
  };

  const editItemClickHandler = (value) => {
    if (!isOpenSide) {
      toggleSideBar();
    } else {
      setIsOpenSide(true);
    }
    setSelectedDto(value);
  };

  const validateCards = (
    dataCardsArrived,
    dataCardsRadius,
    dataCardOnTheMove,
    dataCardDone
  ) => {
    setFilterArrived(
      dataCardsArrived.map((value) => (
        <List
          key={uuid()}
          className="smartgo-list-cards"
          dense
          component="div"
          role="list"
        >
          <ListItem
            className="list-border"
            key={uuid()}
            role="listitem"
            button
            onClick={() => editItemClickHandler(value)}
          >
            <SmartGoCard smartGoCard={value} />
          </ListItem>
        </List>
      ))
    );
    setFilterRadius(
      dataCardsRadius.map((value) => (
        <List
          key={uuid()}
          className="smartgo-list-cards"
          dense
          component="div"
          role="list"
        >
          <ListItem
            className="list-border"
            key={uuid()}
            role="listitem"
            button
            onClick={() => editItemClickHandler(value)}
          >
            <SmartGoCard smartGoCard={value} />
          </ListItem>
        </List>
      ))
    );
    setFilterOnTheMove(
      dataCardOnTheMove.map((value) => (
        <List
          key={uuid()}
          className="smartgo-list-cards"
          dense
          component="div"
          role="list"
        >
          <ListItem
            className="list-border"
            key={uuid()}
            role="listitem"
            button
            onClick={() => editItemClickHandler(value)}
          >
            <SmartGoCard smartGoCard={value} />
          </ListItem>
        </List>
      ))
    );
    setFilterDone(
      dataCardDone.map((value) => (
        <ListItem
          className={
            value.status === SMARTGO_STATUS.STATUS_CANCELED
              ? 'list-border-bg-canceled'
              : 'list-border'
          }
          key={uuid()}
          role="listitem"
          button
          onClick={() => editItemClickHandler(value)}
        >
          <SmartGoCard smartGoCard={value} />
        </ListItem>
      ))
    );
  };

  const converterToSmartGoCard = (item) => {
    return {
      ...item,
      responsibleId: item.responsible.id,
      responsibleName: item.responsible.fullName,
      studentId: item.student.id,
      studentName: item.student.fullName,
      classesNames: item.student.classesNames,
      profilePhotoUrl: item.student.profilePhotoUrl,
      creationDateMs: `${format(item.creationDateMs, 'HH:mm')}`,
      lastLocationUpdate: `${format(item.lastLocationUpdate, 'HH:mm')}`,
      registry: item.entry.itemNote.shortName,
      hourNote: item.entry.hourNote,
      updatedAtMsFormated: `${format(item.updatedAtMs, 'HH:mm')}`,
    };
  };

  const filterByArrived = (smartgos) => {
    return smartgos.filter(
      (value) => value.status === SMARTGO_STATUS.STATUS_RUNNING && value.arrived
    );
  };

  const filterByRadius = (smartgos) => {
    return smartgos.filter(
      (value) =>
        value.status === SMARTGO_STATUS.STATUS_RUNNING &&
        value.inRadius &&
        !value.arrived
    );
  };

  const filterByOnTheMove = (smartgos) => {
    return smartgos.filter(
      (value) =>
        value.status === SMARTGO_STATUS.STATUS_RUNNING &&
        !value.inRadius &&
        !value.arrived
    );
  };

  const filterByDone = (smartgos) => {
    return smartgos.filter(
      (value) => value.status !== SMARTGO_STATUS.STATUS_RUNNING
    );
  };

  const loadByStatus = (status) => {
    updatePendency(dispatch);
    const query = smartGoByStatus(status);
    GraphQL(query, {})
      .then((res) => {
        const updatedData = res.smartGoByStatus.map((item) =>
          converterToSmartGoCard(item)
        );
        const onArrived = filterByArrived(updatedData);
        const onRadius = filterByRadius(updatedData);
        const onTheMove = filterByOnTheMove(updatedData);
        const done = filterByDone(updatedData);
        validateCards(onArrived, onRadius, onTheMove, done);
      })
      .catch(() => {
        showNotificationAutoDestroy(
          'danger',
          t('errors.title'),
          t('errors.error-to-loading')
        );
      });
  };

  const changeActiveTab = (tab) => {
    sessionStorage.setItem(TAB, tab);
  };

  const getStatus = (value) => {
    return value === RUNING_ITEMS_TAB
      ? SMARTGO_STATUS.STATUS_RUNNING
      : SMARTGO_STATUS.STATUS_FINISHED;
  };

  const toggleTab = (index) => {
    changeActiveTab(index);
    loadByStatus(getStatus(index));
  };

  const loadSmartGoPendencyQuantity = () => {
    const query = smartGoPendencyQuantity();
    GraphQL(query, {}).then((res) => {
      if (res.smartGoPendencyQuantity.pendencyQuantity !== 0) {
        loadByStatus(SMARTGO_STATUS.STATUS_RUNNING);
      }
    });
  };

  const handleSubmit = (smartcard, smartStatus, statusAccess) => {
    toggleSideBar();
    const values = { smartcard, smartStatus, statusAccess };
    const mutation = saveSmartGoMutation(values);
    GraphQL(mutation, {})
      .then(() => {
        showNotificationAutoDestroy(
          'success',
          t('success.title'),
          t('success.successfully-saved')
        );
        toggleTab(RUNING_ITEMS_TAB);
        loadSmartGoPendencyQuantity();
        updatePendency(dispatch);
      })
      .catch(() => {
        showNotificationAutoDestroy(
          'danger',
          t('notifications.error'),
          t('errors.error-to-save')
        );
      });
  };

  const onMessageReceived = () => {
    const tab = getActiveTab();
    loadByStatus(getStatus(tab));
  };

  const onConnected = (domain) => {
    stompClient.subscribe(`/topic/smartgo/${domain}`, onMessageReceived);
  };

  const getDomainSchool = async () => {
    const domain = await getDomain();
    return domain;
  };

  const onError = (err) => {
    console.error('Error ==> ', err);
    // eslint-disable-next-line no-use-before-define
    getDomainSchool().then((domain) => connectToWs(domain));
  };

  const connectToWs = (domain) => {
    const sockJS = new SockJS(`${DEFAULT_API_URL}/ws?token=${token}`, {
      transports: ['websocket'],
    });
    stompClient = Stomp.over(sockJS);
    if (domain) {
      stompClient.connect({}, () => onConnected(domain), onError);
    } else {
      getDomainSchool().then((domainSchool) => connectToWs(domainSchool));
    }
    stompClient.debug = null;
  };

  const onDisconnect = () => {
    if (stompClient.connected) {
      stompClient.disconnect();
    }
  };

  useEffect(() => {
    getDomainSchool().then((domain) => {
      connectToWs(domain);
    });
    loadSmartGoPendencyQuantity();
    changeActiveTab(RUNING_ITEMS_TAB);
    return () => onDisconnect();
  }, []);

  useEffect(() => {
    setIsOpenSide(false);
  }, [activeTab]);

  return (
    <MuiThemeProvider>
      <Container className="smartgo-container">
        <Container className={isOpenSide ? 'smartcard-container' : ''}>
          <Card>
            <CardBody>
              <div className="card__title">
                <h5 className="bold-text">{t('panels.smartgo')}</h5>
              </div>
              <Col>
                <div className="tabs tabs--justify tabs--bordered-bottom">
                  <div className="tabs__wrap">
                    <Nav tabs>
                      <NavItem>
                        <NavLink
                          className={classnames({
                            active: activeTab === RUNING_ITEMS_TAB,
                          })}
                          onClick={() => {
                            toggleTab(RUNING_ITEMS_TAB);
                          }}
                        >
                          {t('general.pending')}
                        </NavLink>
                      </NavItem>
                      <NavItem>
                        <NavLink
                          className={classnames({
                            active: activeTab === FINISHED_ITEMS_TAB,
                          })}
                          onClick={() => {
                            toggleTab(FINISHED_ITEMS_TAB);
                          }}
                        >
                          {t('general.completed')}
                        </NavLink>
                      </NavItem>
                    </Nav>
                    <TabContent activeTab={activeTab}>
                      <TabPane tabId="1">
                        {filterOnTheMove.length ||
                        filterRadius.length ||
                        filterArrived.length ? (
                          <div className="smartgo-cards-container">
                            <div className="smartgo-grid">
                              <div>
                                <Card className="smartgo-cards">
                                  <p className="smartgo-cards-title">
                                    {t('smartgo.on-the-move')}
                                  </p>
                                  {filterOnTheMove}
                                </Card>
                              </div>
                              <div>
                                <Card className="smartgo-cards">
                                  <p className="smartgo-cards-title">
                                    {t('smartgo.on-the-radius')}
                                  </p>
                                  {filterRadius}
                                </Card>
                              </div>
                              <div>
                                <Card className="smartgo-cards">
                                  <p className="smartgo-cards-title">
                                    {t('smartgo.school-perimeter')}
                                  </p>
                                  {filterArrived}
                                </Card>
                              </div>
                            </div>
                          </div>
                        ) : (
                          <Alert className="alert-notification" color="info">
                            {t('smartgo.no-pending-found')}
                          </Alert>
                        )}
                      </TabPane>
                    </TabContent>
                    <TabContent activeTab={activeTab}>
                      <TabPane tabId="2">
                        {filterDone.length ? (
                          <List
                            className="smartgo-list-cards"
                            dense
                            component="div"
                            role="list"
                          >
                            {filterDone}
                          </List>
                        ) : (
                          <Alert className="alert-notification" color="info">
                            {t('smartgo.no-pending-found')}
                          </Alert>
                        )}
                      </TabPane>
                    </TabContent>
                  </div>
                </div>
              </Col>
            </CardBody>
          </Card>
        </Container>
        <SideBar
          toggle={toggleSideBar}
          dto={selectedDto}
          isOpen={isOpenSide}
          handleSubmit={handleSubmit}
        />
      </Container>
    </MuiThemeProvider>
  );
};

SmartGo.propTypes = {
  t: PropTypes.func.isRequired,
  dispatch: PropTypes.func.isRequired,
};

export default withTranslation('common')(
  connect((state) => ({
    loading: state.loading,
  }))(SmartGo)
);
